export default __webpack_public_path__ + "static/media/avatar-2.d1a5448c.svg";